<template>
  <button class="header-menu-button" @click="$emit('click')">
    {{ decodeLabel(label) }}
    <slot />
  </button>
</template>

<script lang="ts">
import Utility from '@/common/UtilityFunctions.js';
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'CviHeaderMenuButton',
  props: {
    label: {
      type: String,
      default: () => ''
    }
  },
  methods: {
    decodeLabel(label: string): string {
      return Utility.decodeHtml(label);
    }
  }
});
</script>

<style lang="scss" scoped>
@import 'src/styles/all.scss';
@import 'node_modules/foundation-sites/scss/util/util';

a.header-menu-butto {
  text-decoration: none;
}

.header-menu-button {
  cursor: pointer;
  font-family: inherit;
  font-weight: 500;
  text-align: center;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  width: fit-content;
  white-space: nowrap;
  gap: rem-calc(4px);
  font-size: rem-calc(16px);
  line-height: rem-calc(24px);
  height: rem-calc(48px);
  padding: rem-calc(12px) rem-calc(24px);
  border-radius: rem-calc(64px);
  border-width: rem-calc(2px);
  border-style: solid;
  border-color: rgba(0, 0, 0, 0.1);
  background: none;
  color: $primary-color;

  &:hover:not(&:disabled) {
    background-color: rgba(0, 0, 0, 0.04);
  }
}

@include breakpoint(small only) {
  .header-menu-button {
    width: 100%;
    display: flex;
    justify-content: center;
  }
}
</style>
